import { gql } from '@common/hooks';
import { SupplierInvitation } from '@institutions/graphql/queries/supplier-invitation-by-token';

export const SupplierInvitationAnswerMutation = gql`
  mutation AnswerSupplierInvitation(
    $id: String!
    $input: AnswerSupplierInvitationInput!
  ) {
    answerSupplierInvitation(id: $id, input: $input) {
      supplierInvitation {
        id
        status
      }
    }
  }
`;

export type SupplierInvitationAnswerResponse = {
  supplierInvitation: SupplierInvitation;
};

export type SupplierInvitationAnswerVariables = {
  id: string;
  input: {
    accept: boolean;
    answerMessage: string;
  };
};
